<template>
    <div
        v-if="isLoading"
        data-spec-class="overlay-loading"
        class="absolute inset-0 z-10 flex items-center justify-center rounded bg-white/80"
    >
        <div class="flex flex-col items-center gap-2 text-gray-600">
            <BaseSpinner />
            <span>
                <slot>{{ t('general.updatingData') }}</slot>
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseSpinner from './BaseSpinner.vue';

interface Props {
    isLoading: boolean;
}

defineProps<Props>();

const { t } = useI18n();
</script>
